module.exports = __webpack_public_path__ + "assets/img/c87adfce4076fa7c2ed39eed7833402d.svg";